import { SegmentedControl } from '@mantine/core';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES, SupportedLanguage } from '../../../i18n';

interface LanguageSwitcherProps {
    size?: 'xs' | 'sm' | 'md';
    fullWidth?: boolean;
}

function LanguageSwitcher({ size = 'xs', fullWidth = true }: LanguageSwitcherProps) {
    const { t, i18n } = useTranslation('common');

    const currentLanguage = (
        SUPPORTED_LANGUAGES.includes(i18n.language as SupportedLanguage) ? i18n.language : 'th'
    ) as SupportedLanguage;

    const handleChange = useCallback(
        (value: string) => {
            i18n.changeLanguage(value);
        },
        [i18n]
    );

    return (
        <SegmentedControl
            aria-label={t('languages.label')}
            size={size}
            fullWidth={fullWidth}
            value={currentLanguage}
            onChange={handleChange}
            data={[
                { label: t('languages.th', 'Thai'), value: 'th' },
                { label: t('languages.en', 'English'), value: 'en' },
            ]}
        />
    );
}

export default memo(LanguageSwitcher);
